import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
interface AnimatedSectionProps {
  children: React.ReactNode;
  animation?: 'fade-up' | 'fade-in' | 'slide-left' | 'slide-right' | 'scale';
  delay?: number;
}
export function AnimatedSection({
  children,
  animation = 'fade-up',
  delay = 0
}: AnimatedSectionProps) {
  const {
    ref,
    isVisible
  } = useIntersectionObserver({
    threshold: 0.1
  });
  const animations = {
    'fade-up': 'translate-y-10 opacity-0',
    'fade-in': 'opacity-0',
    'slide-left': 'translate-x-10 opacity-0',
    'slide-right': '-translate-x-10 opacity-0',
    scale: 'scale-95 opacity-0'
  };
  const visibleClass = 'translate-y-0 translate-x-0 opacity-100 scale-100';
  return <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? visibleClass : animations[animation]}`} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-3">
      {children}
    </div>;
}